import { render, staticRenderFns } from "./YbRegCard.vue?vue&type=template&id=0d84fed4&scoped=true&"
import script from "./YbRegCard.vue?vue&type=script&lang=js&"
export * from "./YbRegCard.vue?vue&type=script&lang=js&"
import style0 from "./YbRegCard.vue?vue&type=style&index=0&id=0d84fed4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d84fed4",
  null
  
)

export default component.exports